import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigModule, CmsConfig, I18nModule } from '@spartacus/core';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { MatDialogModule } from '@angular/material/dialog';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DatePipe } from '@angular/common';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbDataExtractionRequestComponent } from './kb-data-extraction-request.component';
import { KbDataExtractionRequestLeftSideNavigationComponent } from './kb-data-extraction-request-left-side-navigation/kb-data-extraction-request-left-side-navigation.component';
import { KbDataExtractionOverviewComponent } from './kb-data-extraction-overview/kb-data-extraction-overview.component';
import { BendixDataExtractionDisclaimerComponent } from './bendix-data-extraction-disclaimer/bendix-data-extraction-disclaimer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KbCustomerVehicleOwnerComponent } from './kb-customer-vehicle-owner/kb-customer-vehicle-owner.component';
import { KbRequestorComponent } from './kb-requestor/kb-requestor.component';
import { KbReportECURecipientComponent } from './kb-report-ecu-recipient/kb-report-ecu-recipient.component';
import { KbVehicleInformationComponent } from './kb-vehicle-information/kb-vehicle-information.component';
import { KbECUInformationComponent } from './kb-ecu-information/kb-ecu-information.component';
import { KbIncidentInformationComponent } from './kb-incident-information/kb-incident-information.component';
import { KbReturnShippingInformationComponent } from './kb-return-shipping-information/kb-return-shipping-information.component';



@NgModule({
  declarations: [
    KbDataExtractionRequestComponent,
    KbDataExtractionRequestLeftSideNavigationComponent,
    KbDataExtractionOverviewComponent,
    BendixDataExtractionDisclaimerComponent,
    KbCustomerVehicleOwnerComponent,
    KbRequestorComponent,
    KbReportECURecipientComponent,
    KbVehicleInformationComponent,
    KbECUInformationComponent,
    KbIncidentInformationComponent,
    KbReturnShippingInformationComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    MatDialogModule,
    BsDatepickerModule,
    ReactiveFormsModule,
    FormsModule,
    RecaptchaFormsModule,
    RecaptchaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        BendixDataExtractionRequestFlexComponent: {
          component: KbDataExtractionRequestComponent, guards: [SecureGuard]
        }
      }
    } as CmsConfig)
  ],
  providers: [DatePipe]
})
export class KbDataExtractionRequestModule { }
